// Wraps the edge functions. All calls are fire-and-forget from the client.
// Actual delivery requires TWILIO_* and RESEND_* env vars set in Vercel.

const API_BASE = import.meta.env.VITE_APP_URL || '';

async function post(path, body) {
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    return res.ok ? res.json() : null;
  } catch { return null; }
}

export async function sendSMS({ to, body }) {
  return post('/api/send-sms', { to, body });
}

export async function sendEmail({ to, subject, html }) {
  return post('/api/send-email', { to, subject, html });
}

// ─── Estimate-specific triggers ───────────────────────────────────────────────

export async function notifyEstimateSent(estimate) {
  const shareUrl = estimate.shareToken
    ? `${window.location.origin}/e/${estimate.shareToken}`
    : null;
  const link = shareUrl ? `\n\nView & approve: ${shareUrl}` : '';

  if (estimate.customerPhone) {
    await sendSMS({
      to: estimate.customerPhone,
      body: `Hi ${estimate.customerName?.split(' ')[0] || 'there'}! Your wrap estimate ${estimate.estimateNumber} is ready.${link}`,
    });
  }
  if (estimate.customerEmail) {
    await sendEmail({
      to: estimate.customerEmail,
      subject: `Your Wrap Estimate ${estimate.estimateNumber} is Ready`,
      html: `<p>Hi ${estimate.customerName?.split(' ')[0] || 'there'},</p><p>Your estimate is ready to review.</p>${shareUrl ? `<p><a href="${shareUrl}">View Estimate</a></p>` : ''}<p>Total: $${estimate.total?.toFixed(2)}</p>`,
    });
  }
}

export async function notifyEstimateApproved(estimate) {
  // Notify shop owner / assigned tech (internal)
  // In production, send to org's notification email stored in settings
  console.info('[messaging] estimate approved:', estimate.estimateNumber);
}

export async function notifyInvoiceDue(invoice) {
  if (invoice.customerPhone) {
    await sendSMS({
      to: invoice.customerPhone,
      body: `Reminder: Invoice ${invoice.invoiceNumber} for $${invoice.total?.toFixed(2)} is due ${invoice.dueAt ? new Date(invoice.dueAt).toLocaleDateString() : 'soon'}.`,
    });
  }
}
